import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "fixed inset-0 overflow-y-auto"
};
const _hoisted_2 = {
  class: "flex min-h-full items-center justify-center p-4 sm:p-8 text-center"
};
const _hoisted_3 = {
  class: "mt-4 space-y-4 max-h-[70vh] overflow-y-auto overflow-x-hidden"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  class: "mt-6 flex justify-end space-x-3"
};
const _hoisted_6 = {
  disabled: "",
  class: "btn2 inline-flex justify-center rounded-full px-3 py-1.5 border hover:bg-gray-50 dark:hover:bg-gray-700 shadow-lg hover:shadow-lg bg-gray-100 dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-slate-600 dark:text-slate-400 cursor-not-allowed"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ShieldExclamationIcon = _resolveComponent("ShieldExclamationIcon");
  const _component_TransitionChild = _resolveComponent("TransitionChild");
  const _component_DialogTitle = _resolveComponent("DialogTitle");
  const _component_DialogPanel = _resolveComponent("DialogPanel");
  const _component_Dialog = _resolveComponent("Dialog");
  const _component_TransitionRoot = _resolveComponent("TransitionRoot");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.openDialog && $options.openDialog(...args)),
    class: "btn flex items-center justify-center px-3 py-2 rounded-full text-white hover:bg-white hover:border-slate-300 hover:shadow-lg hover:text-indigo-500 dark:hover:bg-white dark:hover:text-white transition-colors duration-200"
  }, [_createVNode(_component_ShieldExclamationIcon, {
    class: "hidden w-5 h-5 mr-1 xl:mr-2 sm:block"
  }), _createTextVNode(" " + _toDisplayString(_ctx.$t("HeaderView.HeaderTerms.disclaimer")), 1)]), _createVNode(_component_TransitionRoot, {
    appear: "",
    show: _ctx.isDialogOpen,
    as: "template"
  }, {
    default: _withCtx(() => [_createVNode(_component_Dialog, {
      as: "div",
      class: "relative z-10",
      open: _ctx.isDialogOpen
    }, {
      default: _withCtx(() => [_createVNode(_component_TransitionChild, {
        as: "template",
        enter: "duration-300 ease-out",
        "enter-from": "opacity-0",
        "enter-to": "opacity-100",
        leave: "duration-200 ease-in",
        "leave-from": "opacity-100",
        "leave-to": "opacity-0"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createElementVNode("div", {
          class: "fixed inset-0 bg-black/25"
        }, null, -1)])),
        _: 1
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_TransitionChild, {
        as: "template",
        enter: "duration-300 ease-out",
        "enter-from": "opacity-0 scale-95",
        "enter-to": "opacity-100 scale-100",
        leave: "duration-200 ease-in",
        "leave-from": "opacity-100 scale-100",
        "leave-to": "opacity-0 scale-95"
      }, {
        default: _withCtx(() => [_createVNode(_component_DialogPanel, {
          style: {
            "background": "#F6F9FB"
          },
          class: "w-full max-w-4xl transform overflow-hidden rounded-lg bg-white dark:bg-white p-3 sm:p-6 text-left align-middle shadow-lg dark:shadow-gray-900 transition-all"
        }, {
          default: _withCtx(() => [_createVNode(_component_DialogTitle, {
            as: "h3",
            class: "text-xl font-medium leading-6 text-slate-800 dark:text-black"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("HeaderView.HeaderTerms.disclaimer")), 1)]),
            _: 1
          }), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
            innerHTML: _ctx.$t('HeaderView.HeaderTerms.content')
          }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("button", _hoisted_6, _toDisplayString(_ctx.$t("HeaderView.HeaderTerms.disagree")), 1), _createElementVNode("button", {
            class: "btn2 inline-flex justify-center rounded-full px-3 py-1.5 shadow-lg hover:shadow-lg bg-indigo-500 dark:bg-indigo-600 text-black hover:bg-indigo-600 dark:hover:bg-indigo-500 transition-colors duration-200",
            onClick: _cache[1] || (_cache[1] = (...args) => $options.closeDialog && $options.closeDialog(...args))
          }, _toDisplayString(_ctx.$t("HeaderView.HeaderTerms.agree")), 1)])]),
          _: 1
        })]),
        _: 1
      })])])]),
      _: 1
    }, 8, ["open"])]),
    _: 1
  }, 8, ["show"])], 64);
}